import { forwardRef } from 'react';
import { Box } from '@cp/ds/src/components/box';
import { HeartActiveIcon, HeartIcon } from '@cp/ds/src/icons/mobileMenu';
import { SvgIconComponent } from '@cp/ds';
import { SvgIconProps } from '@cp/ds/src/icons';
import { Badge } from '@cp/ds/src/components/badge';
import { useFavorites } from 'src/features/client/current/favorite';

export const withFavoritesIcon: (isFavorites: Boolean, hasBage?: boolean) => SvgIconComponent = (isFavarites, hasBage = true) =>
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    const favorites = useFavorites();
    const IconComponent = isFavarites ? HeartActiveIcon : HeartIcon;
    return (
      <Badge badgeContent={hasBage && !!favorites.length ? favorites.length : null}>
        <Box sx={{ position: 'relative', width: 'max-content', height: 32 }}>
          <IconComponent {...props} ref={ref} />
        </Box>
      </Badge>
    );
  });
